var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaneTicketIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 48 48",
    height: "48px",
    viewBox: "0 0 48 48",
    width: "48px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fillRule: "evenodd"
    },
    height: 3.099,
    transform: "matrix(-0.7153 -0.6988 0.6988 -0.7153 34.5846 53.6771)",
    width: 6.244,
    x: 25.105,
    y: 18.244
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.068,32.555l-0.184-0.264l0.006-0.002l-4.778-6.803l0.357-1.031l0.098-0.286l0.604-1.745    c0.292-0.844-0.155-1.76-0.997-2.052c-0.841-0.292-1.758,0.156-2.051,0.996l-0.604,1.745l-0.099,0.286l-0.357,1.032l-6.608,2.096    L10.947,26.9l0.001,0.016c-0.263,0.062-0.492,0.236-0.585,0.51c-0.147,0.422,0.077,0.879,0.499,1.027    c0.13,0.043,0.257,0.047,0.383,0.027l6.272,0.422l-0.837,2.42l-3.607,2.174l-0.082,0.232l-0.171,0.498l0.764,0.264l0.1,0.035    l3.158-0.51l-0.07,0.209l-0.118,0.338L16.535,34.9c-0.084,0.246,0.012,0.504,0.211,0.652c0.025,0.02,0.053,0.027,0.082,0.045    c0.037,0.027,0.066,0.035,0.066,0.035c0.056,0.021,0.113,0.031,0.17,0.029c0.246,0.006,0.479-0.135,0.565-0.385l0.117-0.338    l0.117-0.338l0.076-0.215l1.832,2.242l0.402,0.141l0.763,0.268l0.171-0.498l0.065-0.188l0.022-0.061l-1.467-3.916l0.838-2.42    l5.223,3.559c0.087,0.092,0.19,0.174,0.316,0.215c0.425,0.145,0.883-0.078,1.029-0.498c0.081-0.23,0.041-0.471-0.071-0.666    L27.068,32.555z",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.46,13.257c-1.923,1.961-5.072,1.995-7.038,0.077c-1.969-1.921-2.004-5.078-0.084-7.045l-2.108-2.061    c0,0-0.002,0.006-0.004,0.007l-4.279-4.179L0.15,28.5l4.265,4.168l0.622,0.607l9.366,9.15l1.383,1.355l4.263,4.164L47.85,19.5    L41.46,13.257z M33.872,28.111L19.981,42.328l-1.588-1.553l-3.437-3.359l-4.163-4.068h0.001l-2.817-2.75l-0.417-0.408    l-0.655-0.641l-1.139-1.113l13.89-14.214l2.842,2.779l2.082-2.13l-2.842-2.778l6.25-6.398l2.235,2.182    c-0.658,2.642,0.034,5.546,2.117,7.587c2.096,2.048,5.019,2.675,7.651,1.959l2.211,2.16l-6.248,6.392l-2.727-2.66l-2.089,2.134    L33.872,28.111z",
    style: {
      fillRule: "evenodd"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneTicketIcon);
export default __webpack_public_path__ + "static/media/PlaneTicketIcon.84227c9b.svg";
export { ForwardRef as ReactComponent };